document.addEventListener('DOMContentLoaded', function() {
  const track = document.querySelector('.carousel-track');
  const slides = Array.from(track.children);
  const nextButton = document.querySelector('.carousel-arrow.next');
  const prevButton = document.querySelector('.carousel-arrow.prev');
  const dotsNav = document.querySelector('.carousel-nav');
  const dots = Array.from(dotsNav.children);
  
  // Check if we're on mobile
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  
  if (isMobile) {
      // Mobile behavior - carousel functionality
      const slideWidth = slides[0].getBoundingClientRect().width;
      
      // Arrange slides next to one another
      slides.forEach((slide, index) => {
          slide.style.left = slideWidth * index + 'px';
      });
      
      let currentSlide = 0;
      let autoSlideInterval;
      
      // Move to target slide
      const moveToSlide = (targetIndex) => {
          track.style.transform = `translateX(-${slideWidth * targetIndex}px)`;
          currentSlide = targetIndex;
          
          // Update dots
          dots.forEach(dot => dot.classList.remove('active-dot'));
          dots[targetIndex].classList.add('active-dot');
      };
      
      // Start auto-sliding
      const startAutoSlide = () => {
          autoSlideInterval = setInterval(() => {
              let nextIndex = currentSlide + 1;
              if (nextIndex >= slides.length) nextIndex = 0;
              moveToSlide(nextIndex);
          }, 8000);
      };
      
      // When I click left, move slides to the left
      prevButton.addEventListener('click', e => {
          clearInterval(autoSlideInterval);
          let prevIndex = currentSlide - 1;
          if (prevIndex < 0) prevIndex = slides.length - 1;
          moveToSlide(prevIndex);
          startAutoSlide();
      });
      
      // When I click right, move slides to the right
      nextButton.addEventListener('click', e => {
          clearInterval(autoSlideInterval);
          let nextIndex = currentSlide + 1;
          if (nextIndex >= slides.length) nextIndex = 0;
          moveToSlide(nextIndex);
          startAutoSlide();
      });
      
      // When I click the nav indicators, move to that slide
      dotsNav.addEventListener('click', e => {
          const targetDot = e.target.closest('.carousel-dot');
          
          if (!targetDot) return;
          
          clearInterval(autoSlideInterval);
          const targetIndex = parseInt(targetDot.dataset.index);
          moveToSlide(targetIndex);
          startAutoSlide();
      });
      
      // Set data-index attributes for slides
      slides.forEach((slide, index) => {
          slide.dataset.index = index;
      });
      
      // Start auto-sliding on page load
      startAutoSlide();
      
      // Pause auto-slide on hover
      const carouselContainer = document.querySelector('.carousel-container');
      carouselContainer.addEventListener('mouseenter', () => {
          clearInterval(autoSlideInterval);
      });
      
      carouselContainer.addEventListener('mouseleave', () => {
          startAutoSlide();
      });
  } else {
      // Desktop behavior - show all 3 cards, hide navigation
      nextButton.style.display = 'none';
      prevButton.style.display = 'none';
      dotsNav.style.display = 'none';
  }
});